export default {"src":"/_next/static/media/ship-go-dark.e289291e.svg","height":40,"width":115,"blurWidth":0,"blurHeight":0};